import DungeonsAndDragons from "./DungeonsAndDragons";

export const DungeonsAndDragonsImages = {
    brandingImage: DungeonsAndDragons.Oblador,
    gallery: Object.values(DungeonsAndDragons)
}

export const DungeonsAndDragonsImageSizes = [
    {width: 6144, height: 6144},
    {width: 4096, height: 3072},
    {width: 1056, height: 994},
    {width: 3508, height: 4961},
    {width: 1440, height: 960},
    {width: 4000, height: 4000},
    {width: 4096, height: 4096},
    {width: 4096, height: 3072},
    {width: 4096, height: 3072},
    {width: 4096, height: 3072},
    {width: 4096, height: 3072},
    {width: 4096, height: 3072},
    {width: 6144, height: 4608},
    {width: 4096, height: 3072},
    {width: 8192, height: 6144}
]